/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { navigate, Link } from "@reach/router";
import { gql } from "graphql-tag";
import { useMutation } from "@apollo/client";
import { Viewer } from "components/auth/types";
import {
  TemplateGroupCreateInput,
  createTemplateGroup,
  createTemplateGroupVariables,
} from "types/gql-types";
import logger from "services/logger";
import { useSnackbar } from "components/haven-design/snackbar";
import { TEMPLATE_DASHBOARD_ROUTE } from "../template-groups";
import styles from "./template-group.module.css";
import { TemplateForm } from "./form";

const CREATE_TEMPLATE = gql`
  mutation createTemplateGroup($data: TemplateGroupCreateInput!) {
    createTemplateGroup(data: $data) {
      id
    }
  }
`;

const SERVER_ERROR =
  "Unable to create template. Please try again or contact support@havenconnect.com.";

interface Props {
  viewer: Viewer;
  path: string;
}

const NewTemplate: React.FC<Props> = (props) => {
  const [createTemplateGroupFunc] = useMutation<
  createTemplateGroup,
  createTemplateGroupVariables
  >(CREATE_TEMPLATE, { refetchQueries: ["myTemplateGroups"] });
  const [isSending, setIsSending] = useState(false);

  const { openSnackbar } = useSnackbar();


  const handleSubmit = (templateData: TemplateGroupCreateInput) => {
    setIsSending(true);
    createTemplateGroupFunc({ variables: { data: templateData } })
      .then(() => {
        navigate(TEMPLATE_DASHBOARD_ROUTE);
      })
      .catch((err) => {
        logger.sendError(err);
        openSnackbar({ message: SERVER_ERROR, status: "error", duration: 5000 });
      })
      .finally(() => setIsSending(false));
  };

  return (
    <>
      <div className={styles.formTitle}>
        <span className={styles.formTitleLink}>
          <Link to={TEMPLATE_DASHBOARD_ROUTE}>Templates</Link>
        </span>{" "}
          &gt; Create Template
      </div>
      <div className={styles.templateFormContainer}>
        <TemplateForm
          isSending={isSending}
          handleSubmit={handleSubmit}
          viewer={props.viewer}
          onCancel={() => navigate(TEMPLATE_DASHBOARD_ROUTE)}
        />
      </div>
    </>
  );
};
export default NewTemplate;
